import Close from 'components/lib/icons/Close'
import NakedButton from 'components/lib/NakedButton'
import useForceFocus from 'hooks/useForceFocus'
import useWidgetAlignment from 'hooks/useWidgetAlignment'
import React, { useRef } from 'react'

import './style.css'

interface MessageCloseButtonProps {
  onClick: (event: any) => void
  shouldFocus?: boolean
}

const MessageCloseButton = ({ onClick, shouldFocus = false }: MessageCloseButtonProps) => {
  const widgetAlignment = useWidgetAlignment()
  const closeButtonRef = useRef(null)

  useForceFocus(closeButtonRef, shouldFocus)

  const handleOnClick = (event) => {
    if (closeButtonRef?.current) {
      closeButtonRef?.current.blur()
    }

    onClick(event)
  }

  return (
    <NakedButton
      onClick={handleOnClick}
      ref={closeButtonRef}
      className={`drift-widget-message-close-button drift-widget-close-button--align-${widgetAlignment}`}
      aria-label="Close Drift Widget messenger preview overlay"
    >
      <Close width={10} height={10} />
    </NakedButton>
  )
}

export default MessageCloseButton
